import Vue from 'vue'
import Vuex from 'vuex'
import PadAuthStore from '@/stores/PadAuthStore'
import PadMessageStore from '@/stores/PadMessageStore'
import PadLotStore from '@/stores/PadLotStore'
import PadSaleStore from '@/stores/PadSaleStore'
import PadErrataStore from '@/stores/PadErrataStore'
import PadVisaStore from '@/stores/PadVisaStore'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth: PadAuthStore,
        msg: PadMessageStore,
        lot: PadLotStore,
        sale: PadSaleStore,
        errata: PadErrataStore,
        visa: PadVisaStore
    }
})
